import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from './lib/sentry-config';
import App from './App.tsx';
import './index.css';

// Initialize Sentry
initSentry();

console.log(`[admin] env=${import.meta.env.VITE_ENV} commit=${import.meta.env.VITE_GIT_COMMIT_SHA || 'local'}`);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);